<div *ngIf="((userSubscription.plan.recurring || userSubscription?.plan?.hasAddons) &&
![UserSubscriptionType.REGISTERED, UserSubscriptionType.FREE].includes(userSubscription?.type)) ||
((userSubscription?.type === UserSubscriptionType.FREE && user && (!user.hasHostingTrial || (user.hasHostingTrial &&
user.hostingTrialExpired))) && !userSubscription?.trialBoosterClient)" class="db-plan-billing"
     [ngClass]="{'canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed, userSubscriptionStatus.expired].includes(userSubscription.status) || userSubscription?.stripeSbcrstatus === 'paused'}">
  <div
    [ngClass]="{'db-plan-billing-info__canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed].includes(userSubscription.status)}"
    class="db-plan-billing-info">
    <div class="db-plan-billing-info__inner fo">
      <div>{{'text_subscriptionPrice' | dbText}}</div>
      <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE">
        <ng-container *ngIf="isCurrencyBeforeAmount">{{ currencySymbol }}0</ng-container>
        <ng-container *ngIf="!isCurrencyBeforeAmount">0 {{ currencySymbol }}</ng-container>
      </div>
      <div *ngIf="userSubscription?.type !== UserSubscriptionType.FREE">
        <ng-container *ngIf="isCurrencyBeforeAmount">
          {{ currencySymbol }}{{userSubscription?.plan?.price}}
        </ng-container>
        <ng-container *ngIf="!isCurrencyBeforeAmount">
          {{userSubscription?.plan?.price}} {{ currencySymbol }}
        </ng-container>
      </div>
    </div>
  </div>

  <div
    [ngClass]="{'db-plan-billing-info__canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed].includes(userSubscription.status)}"
    class="db-plan-billing-info" *ngIf="userSubscription?.type !== UserSubscriptionType.FREE">
    <div class="db-plan-billing-info__inner" *ngIf="userSubscription">
      <div>{{ 'text_billingCycle' | dbText }}</div>
      <div>{{ (userSubscription.plan.periodNumber < 12 ? (userSubscription.plan.periodNumber === 1 ? 'text_periodMonthly' : ('Every ' + userSubscription.plan.periodNumber + ' month' + (userSubscription.plan.periodNumber > 1 ? 's' : ''))) : 'text_periodYearly') | dbText }}</div>
    </div>
  </div>
  <div
    [ngClass]="{'db-plan-billing-info__canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed].includes(userSubscription.status)}"
    class="db-plan-billing-info" *ngIf="userSubscription?.status === userSubscriptionStatus.canceled">
    <div class="db-plan-billing-info__inner" *ngIf="userSubscription?.cancelDate">
      <div>{{ (!!userSubscription?.paused ? 'text_pauseDate' : 'text_cancelDate') | dbText }}</div>
      <div>{{userSubscription?.cancelDate | dbDate : 'dd MMM y' : false}}</div>
    </div>
  </div>
  <div
    [ngClass]="{'db-plan-billing-info__canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed].includes(userSubscription.status)}"
    class="db-plan-billing-info"
    *ngIf="userSubscription?.status === userSubscriptionStatus.canceled && userSubscription.expireDate && !userSubscription.isExpired">
    <div class="db-plan-billing-info__inner aaaaa">
      <div>{{ (!!userSubscription?.paused ? 'text_pauseExpirationDate' : 'text_expireDate') | dbText }}</div>
      <div>{{userSubscription?.isExpired && userSubscription.nextBillingDate ?
        (userSubscription.nextBillingDate | dbDate : 'dd MMM y' : false) :
        ((!!userSubscription?.paused ? userSubscription?.pausedExpirationDate : userSubscription.expireDate) | dbDate : 'dd MMM y' : false)
        }}</div>
    </div>
  </div>

  <div
    [ngClass]="{'db-plan-billing-info__canceled': [userSubscriptionStatus.canceled, userSubscriptionStatus.failed].includes(userSubscription.status)}"
    class="db-plan-billing-info"
    *ngIf="userSubscription?.type !== UserSubscriptionType.FREE && userSubscription.status !== userSubscriptionStatus.canceled">
    <div class="db-plan-billing-info__inner"
         *ngIf="(userSubscription.status === userSubscriptionStatus.failed || userSubscription.status === userSubscriptionStatus.expired || userSubscription.status === userSubscriptionStatus.canceled) && userSubscription.expireDate">
      <div>{{userSubscription?.status === userSubscriptionStatus.expired || userSubscription.isExpired ? 'Expired on ' : ('text_expireDate' | dbText) }}</div>
      <div
        [ngClass]="{'color-danger': userSubscription.status === userSubscriptionStatus.expired || userSubscription.isExpired}">{{userSubscription?.isExpired && userSubscription.nextBillingDate ? (userSubscription.nextBillingDate | dbDate : 'dd MMM y' : false) : (userSubscription.expireDate | dbDate : 'dd MMM y' : false)}}</div>
    </div>
    <div class="db-plan-billing-info__inner" *ngIf="userSubscription?.nextBillingDate && !userSubscription.isExpired">
      <div>{{ 'text_expireDate' | dbText }}</div>
      <div>{{userSubscription?.nextBillingDate | dbDate : 'dd MMM y' : false}}</div>
    </div>
    <div class="db-plan-billing-info__inner"
         *ngIf="userSubscription?.nextBillingDate && userSubscription.isExpired && !userSubscription.expireDate">
      <div>{{ 'text_expireDate' | dbText }}</div>
      <div class="color-danger">{{userSubscription?.nextBillingDate | dbDate : 'dd MMM y' : false}}</div>
    </div>
  </div>
</div>
